import { FC } from 'react'
import { SvgProps } from './svgProps'

const DayDeliveryIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || '13'}
    height={height || '13'}
    viewBox="0 0 13 13"
  >
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <path
            d="M0 0H13V13H0z"
            transform="translate(-247.000000, -360.000000) translate(247.000000, 360.000000)"
          />
          <g transform="translate(-247.000000, -360.000000) translate(247.000000, 360.000000) translate(0.866667, 0.866667)">
            <circle
              cx="2.6"
              cy="9.967"
              r="1.3"
              stroke={color || '#F04E23'}
              strokeLinecap="round"
            />
            <circle
              cx="8.667"
              cy="9.967"
              r="1.3"
              stroke={color || '#F04E23'}
              strokeLinecap="round"
            />
            <path
              stroke={color || '#F04E23'}
              strokeLinecap="round"
              d="M8.233 3.467h1c.705 0 1.339.429 1.6 1.083l.29.726c.095.236.144.488.144.742v2.215c0 .718-.582 1.3-1.3 1.3h0M0 6.933V3c0-1.657 1.343-3 3-3h2.233c1.657 0 3 1.343 3 3v.933c0 1.657-1.343 3-3 3H0h0v1.3c0 .718.582 1.3 1.3 1.3h0M3.9 9.533L7.367 9.533"
            />
            <path
              fill={color || '#F04E23'}
              d="M3.045 2.185c.191 0 .353.034.488.1.134.067.234.157.301.27.067.112.1.235.1.368 0 .126-.02.244-.064.353-.044.108-.129.237-.255.385-.125.149-.312.334-.559.557h.928l-.07.549H2.265v-.505c.273-.272.475-.48.606-.627.13-.145.222-.265.273-.36.052-.093.078-.184.078-.27 0-.084-.022-.15-.067-.199-.045-.048-.107-.072-.187-.072-.078 0-.148.02-.21.061-.063.041-.127.105-.193.191l-.398-.333c.1-.144.226-.258.374-.342.148-.084.316-.126.504-.126zm3.022 1.543v.542H5.82v.497h-.685L5.13 4.27H4.125V3.79l.66-1.624.597.222-.54 1.34h.296l.082-.55h.6v.55h.247z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default DayDeliveryIcon
